import React from 'react';
// src/components/ui/EmptyState.tsx
// Shared empty-state pattern (STYLEGUIDE §5: never a bare "No data" — an icon,
// a line saying what would appear here, and one action).

interface EmptyStateProps {
  /** A lucide icon element, e.g. <UsersIcon className="h-6 w-6" />. */
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  /** A single primary action (usually a <Button>). */
  action?: React.ReactNode;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action, className = '' }) => (
  <div className={`text-center py-14 px-6 ${className}`}>
    {icon && (
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-ink-100 text-ink-400">
        {icon}
      </div>
    )}
    <h3 className="text-card-title text-ink-900">{title}</h3>
    {description && <p className="mt-1.5 text-body-sm text-ink-500 max-w-sm mx-auto">{description}</p>}
    {action && <div className="mt-5 flex justify-center">{action}</div>}
  </div>
);

export default EmptyState;
